import { Anchor, Tabs } from 'antd';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 20px;
  background-color: ${(props) => props.theme.colors.primary};
  .tab {
    font-size: 18px;
  }

  @media (max-width: 768px) {
    padding: 15px;
  }
`;

export const ContainerAnchor = styled.div`
  display: grid;
  grid-template-columns: 9fr 1fr;
`;

export const ContainerTexto = styled.div`
  div {
    margin-right: 250px; // Espaço reservado para o Anchor fixo
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    img {
      max-width: 800px;
      align-items: flex-start;
    }
  }
  @media (max-width: 768px) {
    img {
      display: none;
    }
  }
`;

export const StyledTabs = styled(Tabs)`
  flex: 1;
  .ant-tabs-left-bar {
    width: 200px;
  }
  .ant-tabs-content-holder {
    height: calc(100vh - 48px);
    overflow-y: auto;
  }
`;

export const TitleContainer = styled.h1`
  font-family: roboto;
  font-weight: 600;
  font-size: 32px;
  color: #242a31;

  @media (max-width: 768px) {
    font-size: 22px;
  }
`;

export const Title = styled.h2`
  font-family: roboto;
  font-weight: 600;
  font-size: 24px;
  color: #242a31;
  margin-top: 50px;

  @media (max-width: 768px) {
    font-size: 16px;
  }
`;

export const Text = styled.p`
  width: 678px;
  font-family: roboto;
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 150%;
  color: #242a31;

  @media (max-width: 768px) {
    width: 100%;
    font-size: 12px;
  }
`;

export const Tags = styled.div`
  width: 678px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  flex-wrap: wrap;
  @media (max-width: 768px) {
    width: 100%;
    justify-content: left;
  }

  div {
    padding: 5px;
    border-radius: 5px;
    color: #667085;
    font-size: 12px;
    line-height: 16px;
    background-color: #f2f2f5;
    @media (max-width: 768px) {
      margin: 5px;
    }
  }
`;

export const FixedAnchor = styled(Anchor)`
  position: fixed;
  right: 80px; // Distância da borda direita da tela
  top: 100px; // Distância da borda superior da tela
  width: 200px;
`;
